/**
 * Constants related to APIs.
 *
 * These variables represent various API-related configurations and endpoints
 */

export const protocol = window.location.protocol;
const host = window.location.host;
export const ENDPOINT_URL = `${protocol}//${host}/`;
// export const ENDPOINT_URL = 'http://blr04-iocloud.hfcl.com/'; // blr04
// export const ENDPOINT_URL = 'http://blr-iocloud.hfcl.com/'; // ztp of blr04
// export const ENDPOINT_URL = 'https://sanity.in01-iocloud.hfcl.com/'; // Canvas.in04
export const HOST_URL = host;
export const APRECOM_ENDPOINT = ENDPOINT_URL.endsWith('/')
	? ENDPOINT_URL.slice(0, -1)
	: ENDPOINT_URL;
// export const HOST_URL = 'blr04-iocloud.hfcl.com';
// export const HOST_URL = 'sanity.in01-iocloud.hfcl.com';
export const CANVAS_UI_VERSION = '5.3.0.8';
export const LOGIN_API = 'api/login/';
export const LOGOUT_API = 'api/logout/';
export const OTP_VERIFICATION_API =
	'api/multitenant/otp-verify/tenant-create/0/';
export const TENANT_INFO = 'api/aprecomm/gettenantname/';
export const URL_FILTERING = 'https://tantiv4.uk-iocloud.hfcl.com/api/website';
export const GET_GROUP_LIST = 'api/sites/list/';
export const DELETE_GROUP = 'api/sites/delete/';
export const GET_AP_LIST = 'api/devices/list/';
export const GET_AP_LIST_BY_SITE = 'api/sites/device/list/';
export const GET_LITE_SITE_LIST = 'api/sites/filtered-list/';
export const GET_SWITCH_TOPOLOGY_API = 'api/switches/siteglobalconfig/';
export const CONTINOUS_POE_POWER_API = 'api/switches/manage/reboot/';
export const UPDATE_AP = 'api/devices/update/';
export const WPS_NOTIF = 'api/sites/all-ap/wps-event/';
export const GET_AP_REMOTE_ENABLE_ENDPOINT = 'api/devices/rtty/';
export const ADD_AP_SNAPSHOT_ENDPOINT = 'api/maintenance/apsnap/';
export const AP_REBOOT_ENDPOINT = 'api/maintenance/reboot-factory-reset-ap/';
export const AP_BLINK_ENDPOINT = 'api/devices/leds/';
export const DOWNLOAD_AP_SNAPSHOT_API = 'api/maintenance/apsnap/download/';
export const GET_AP_SNAPSHOT_API = 'api/maintenance/apsnap/';
export const DELETE_AP_SNAPSHOT_API = 'api/maintenance/apsnap/delete/';
export const DELETE_AP = 'api/devices/delete/';
export const GET_SSID_DETAILS = 'api/sites/list-site/ssid-details/';
export const GET_SSID_LIST_API = 'api/sites/global-ssid/list/';
export const GET_AP_GROUP_SSID_API = 'api/sites/ap-ssid/list';
export const DELETE_SSID_API = 'api/sites/global-ssid/delete/';
export const DELETE_AP_GROUP_SSID_API = 'api/sites/ap-ssid/delete/';
export const UPDATE_AP_GROUP_SSID_API = 'api/sites/ap-ssid/update/';
export const ADD_AP_GROUP_SSID_API = 'api/sites/ap-ssid/create/';
export const ADD_TIP_SSID_API = 'api/devices/tip/configure/ssid';
export const GET_EACH_TIP_AP_CONFIG = 'api/devices/tip/ap-interface/retrieve/';
export const UPDATE_EACH_TIP_AP_CONFIG = 'api/devices/tip/ap-interface/';
export const UPDATE_EACH_TIP_IP_AP_CONFIG = 'api/devices/tip/ap-ip/update/';
export const GET_RADIO_BAND_LIST_API = 'api/devices/tip/interad';
export const DELETE_TIP_SSID_API = 'api/devices/tip/ssid/update';
export const GET_MAC_ACL_LIST = 'api/sites/global-mac-acl/list/';
export const GET_VLAN_POOL_LIST = 'api/sites/vlan-pool/list/';
export const GET_ACS_SCHEDULER_LIST = 'api/system/acs-schedule/';
export const EDIT_ACS_SCHEDULE_API = 'api/system/acs-schedule/update/';
export const DELETE_ACS_SCHEDULE_API = 'api/system/acs-schedule/delete/';
export const GET_USERS_LIST = 'api/users/';
export const UPDATE_PROFILE_LIST = 'api/accounts/user/';
export const DELETE_USERS = 'api/accounts/user/delete/';
export const SUSPEND_USERS = 'api/accounts/user/kickoff/';
export const GET_ROLES_LIST = 'api/accounts/role-group/list/';
export const GET_ROLES_DETAILS = 'api/accounts/role-group/';
export const ADD_ROLES = 'api/accounts/role-group/create/';
export const ADD_CAPTIVE_PORTALS = 'api/sites/captive-portal/create/';
export const DELETE_CAPTIVE_PORTALS = 'api/sites/captive-portal/delete/';
export const GET_CLIENT_SESSION_HISTORY_LIST =
	'api/sites/client/historical/list/';
export const UPDATE_CAPTIVE_PORTALS = 'api/sites/captive-portal/update/';
export const GET_ADMIN_DETAILS = 'api/accounts/admin/details/';
export const GET_ROLES_PERMISSIONS_LIST = 'api/accounts/user-permission/list/';
export const DELETE_ROLES = 'api/accounts/roles/delete/';
export const UPDATE_PASSWORD_API = 'api/accounts/user/';
export const GET_SSID_SCHEDULER_LIST = 'api/system/ssid-schedule/';
export const EDIT_SSID_SCHEDULE_API = 'api/system/ssid-schedule/update/';
export const DELETE_SSID_SCHEDULE_API = 'api/system/ssid-schedule/delete/';
export const GET_ATF_PROFILE_LIST = 'api/system/atf-profile/';
export const EDIT_ATF_PROFILE_LIST = 'api/system/atf-profile/update/';
export const GET_MULTI_PSK_LIST = 'api/sites/multi-psk/list/';
export const UPDATE_GROUP_API = 'api/sites/update/';
export const ADD_SSID_API = 'api/sites/global-ssid/create/';
export const EDIT_SSID_API = 'api/sites/global-ssid/';
export const GET_EOGRE_LIST = 'api/sites/eogre/list/';
export const GET_NAT_PROFILE_LIST = 'api/system/nat-config/list/';
export const GET_AAA_SERVER_LIST = 'api/sites/global-radius-server/list/';
export const GET_FIRMWARE_MANAGEMENT_LIST =
	'api/maintenance/schedule-firmware/list/';
export const SAVE_TROUBLESHOOT_API = 'api/maintenance/json-publisher/';
export const SAVE_TROUBLESHOOT_API_1 = 'api/maintenance/alarm-converter/';
export const SAVE_TROUBLESHOOT_API_2 = 'api/maintenance/serial-queue-converter/';
export const SWITCH_ALARMS_EVENT = 'api/switches/alarms/events/';
export const GET_SWITCH_FIRMWARE_LIST = 'api/switches/manage/firmware/';
export const GET_FIRMWARE_LIST = 'api/maintenance/firmware/list/';
export const GET_DEVICE_FIRMWARE_MODELS_LIST = 'api/devices/firmware-list/';
export const GET_AUDIT_LOGS = 'api/accounts/audit-log/list/';
export const DOWNLOAD_AUDIT_LOGS_API = 'api/accounts/audit-log/list/';
export const CONTENT_TYPE_LIST = 'api/accounts/content-type/list/';
export const DELETE_FIRMWARE_API = 'api/maintenance/firmware/delete/';
export const DELETE_FIRMWARE_MANAGEMENT_API =
	'api/maintenance/schedule-firmware/delete/';
export const ADD_FIRMWARE_API = 'api/maintenance/firmware/list/';
export const FIRWARE_MANAGEMENT_ADD_SCHEDULE_API =
	'api/maintenance/schedule-firmware/upgrade/';
export const UPDATE_SCHEDULE_FIRMWARE = 'api/maintenance/schedule-firmware/';
export const FIRWARE_MANAGEMENT_ADD_API = 'api/maintenance/firmware/upgrade/';
export const FIRMWARE_SCHEDULE_DOWNLOAD =
	'api/maintenance/schedule-firmware/download/';
export const KICKOFF_CLIENT_API = 'api/sites/client/kickoff/';
export const PACKET_CAPTURE_LIST = 'api/maintenance/pcap/';
export const PACKET_CAPTURE_DELETE = 'api/maintenance/pcap/delete/';
export const PACKET_CAPTURE_STOP = 'api/maintenance/pcap/stop/';
export const PACKET_CAPTURE_DOWNLOAD = 'api/maintenance/pcap/download/';
export const GET_APPRECOM_CNMS_TOKEN = 'api/aprecomm/getcnmstoken/';
export const GET_APRECOMM_URL = 'api/aprecomm/getipaddress/';
export const LOGIN_APRECOMM_URL = ':8081/login';
export const APRECOMM_GRAPH_URL = ':8081/graphql';
export const APRECOMM_NOTIFICATION_URL = ':8081/provision/notification';
export const AP_MODAL_FIRM_DIST_API = 'api/devices/count/';
export const GET_PLAN = 'api/cPortal/iopassPlan/';
export const GET_SPLASH = 'api/cPortal/listPageBuilder/';
export const ADD_SPLASH = 'api/cPortal/';
export const GET_VOUCHERS_LIST = 'api/accounts/voucher-list/';
export const GET_CAPTIVE_PORTALS_LIST = 'api/sites/captive-portal/list/';
export const GET_ADMIN_EMAIL_APPROVAL_LIST = 'api/cPortal/emailAdmin/';
export const GET_COUNTRY_CODE = 'api/sites/country-code/list/';
export const GET_TIME_ZONES = 'api/accounts/time-zone/list/';
export const DELETE_VLAN_POOL_API = 'api/sites/vlan-pool/delete/';
export const ADD_VLAN_POOL_API = 'api/sites/vlan-pool/list/';
export const EDIT_VLAN_POOL_API = 'api/sites/vlan-pool/';
export const DELETE_MULTI_PSK_API = 'api/sites/multi-psk/delete/';
export const ADD_MULTI_PSK_API = 'api/sites/multi-psk/list/';
export const DELETE_EOGRE_API = 'api/sites/eogre/delete/';
export const DELETE_NAT_PROFILE_API = 'api/system/nat-config/delete/';
export const DELETE_AAA_SERVER_API = 'api/sites/global-radius-server/delete/';
export const ADD_EOGRE_API = 'api/sites/eogre/list/';
export const ADD_AAA_SERVER_API = 'api/sites/global-radius-server/list/';
export const EDIT_EOGRE_API = 'api/sites/eogre/';
export const EDIT_AAA_SERVER_API = 'api/sites/global-radius-server/update/';
export const ADD_NAT_PROFILE_API = 'api/system/nat-config/list/';
export const EDIT_NAT_PROFILE_API = 'api/system/nat-config/';
export const DELETE_MAC_ACL_API = 'api/sites/global-mac-acl/delete/';
export const EDIT_MAC_ACL_API = 'api/sites/global-mac-acl/update/';
export const GET_CLIENT_LIST = 'api/sites/client/list/';
export const GET_SWITCH_LIST = 'api/switches/list/';
export const GET_SWITCH_ALARMS_API = 'api/switches/alarm-events/list/';
export const DELETE_SWITCH = 'api/switches/delete/';
export const GET_LICENSES = 'api/accounts/license/about/';
export const GET_SYSTEM_CONFIG = 'api/system/config/list/';
export const UPLOAD_LICENCE_API = 'api/accounts/license/upload/';
export const LICENSE_DETAILS_POPUP = 'api/accounts/license/details-popup/';
export const LICENSE_DETAILS_UPDATE_POPUP =
	'api/accounts/license/update/popup/';
export const DELETE_HISTORICAL_ALARMS = 'api/devices/alarm/history/delete/';
export const GET_GLOBAL_VLAN_LIST = 'api/switches/vlan/list/';
export const ADD_SWITCH_VLAN_API = 'api/switches/vlan/list-create/';
export const GET_PORTS_LIST_FOR_SWITCH = 'api/switches/ports/list-update/';
export const GET_ALL_VLAN_FOR_SWITCH = 'api/switches/vlan/list-update/';
export const GET_ALL_ACL_PORTS_SWITCH = 'api/switches/acl/ports/';
export const GET_ALL_SWITCH_ACL_MAC = 'api/switches/acl/mac/';
export const GET_ALL_SWITCH_ACL_IPV4 = 'api/switches/acl/ipv4/';
export const GET_ALL_SWITCH_ACL_IPV6 = 'api/switches/acl/ipv6/';
export const GET_SWITCH_DETAILS = 'api/switches/update-retrieve/';
export const GET_SWITCH_DETAILS_SITE = 'api/switches/site-retrieve/';
export const GET_SWITCH_DROPDOWN_LIST_API =
	'api/switches/filter-dropdown/list/';
export const GET_SWITCH_MODEL_COUNT = 'api/switches/count/';
export const SWITCH_PARTITION_API = 'api/switches/manage/partition/';
export const UPDATE_PORT_CONFIGURATION = 'api/switches/ports/list-update/';
export const GET_GENERAL_CONFIG_API = 'api/devices/alarms/damp-config/list/';
export const EDIT_GENERAL_CONFIG_API = 'api/devices/alarms/damp-config/patch/';
export const GET_DEVICE_CONFIG_API = 'api/devices/alarms/events/retrieve/2/';
export const EDIT_DEVICE_CONFIG_API = 'api/devices/alarms/events/patch/';
export const GET_NETWORK_CONFIG_API = 'api/devices/alarms/events/retrieve/3/';
export const EDIT_NETWORK_CONFIG_API = 'api/devices/alarms/events/patch/';
export const GET_SYSTEM_CONFIG_API = 'api/devices/alarms/events/retrieve/1/';
export const EDIT_SYSTEM_CONFIG_API = 'api/devices/alarms/events/patch/';
export const GET_ALARMS_REPORT_LIST = 'api/reports/list/';
export const GET_REPORT_PARAM_TYPE_LIST = 'api/reports/params/type/list/';
export const GET_REPORT_PARAM_INTERVAL_LIST =
	'api/reports/params/frequency/list/';
export const GET_REPORT_PARAM_REPEAT_LIST = 'api/reports/params/repeat/list/';
export const GET_HISTORICAL_ALARMS_REPORT_LIST = 'api/reports/alarm/list/';
export const EDIT_ACTIVE_ALARMS_REPORT_LIST = 'api/reports/update/';
export const REPORTS_ALARM_DELETE = 'api/reports/delete/';
export const CUSTOM_REPORT_ALARM_DELETE = 'api/reports/alarm/delete/';
export const GET_MAINTENANCE_INSTANCE_LIST =
	'api/multitenant/push/notification/';
export const GET_CLI_USERS_LIST = 'api/sites/ap-cli-user/list/';
export const ADD_CLI_USERS_API = 'api/sites/ap-cli-user/create/';
export const EDIT_CLI_USERS_API = 'api/sites/ap-cli-user/update/';
export const DELETE_CLI_USERS_API = 'api/sites/ap-cli-user/delete/';
export const GET_GROUP_CONFIGURATION_API = 'api/sites/retrieve/';
export const UPDATE_GROUP_CONFIGURATION_API = 'api/sites/update/';
export const TIP_CONFIGURATION_UPDATE = 'api/devices/tip/configure/update/';
export const TIP_CONFIGURATION_RETRIEVE = 'api/devices/tip/interface/retrieve/';
export const LAN_WAN_TIP_CONFIGURATION_UPDATE = 'api/devices/tip/interface/';
export const UPDATE_ACCESS_POINT_API = 'api/devices/update/';
export const GET_EACH_ACCESS_POINT_API = 'api/devices/retrieve/';
export const GET_AP_LIST_ALL = 'api/devices/filtered-ap/list/';
export const BULK_ACTIONS_TASKS = 'api/system/bulk-action/list/';
export const BULK_ACTION_DELETE = 'api/system/bulk-action/delete/';
export const BULK_ACTION_DOWNLOAD = 'api/system/bulk-action/download/';
export const BULK_ACTION_EDIT = 'api/system/bulk-action/'

export const GET_ROGUE_ACCESS_POINT_API = 'api/devices/rogue/ap/list/';
export const TRUST_ROGUE_TO_KNOWN = 'api/devices/rogue/ap/trust/';
export const ROGUE_KNOWN_DELETE = 'api/devices/rogue/ap/delete/';
export const BULK_KNOWN_ROGUE = 'api/devices/rogue/add/known_ap/';

export const GET_INTERFACE_LIST_API = 'api/devices/list-interfaces/';
export const GET_RADIO_SETTING_CONFIG_LIST = 'api/devices/radioconfig/';
export const GET_TIP_RADIO = 'api/devices/tip/radio/retrieve/';
export const UPDATE_TIP_RADIO = 'api/devices/tip/radio/update/';
export const GET_CLIENT_SESSIONS = 'api/cPortal/listRadacct/';
export const DISCONNECT_CLIENT_SESSIONS = 'api/cPortal/disconnectMessage/';
export const REPORT_DOWNLOAD = 'api/reports/download';
export const REPORT_DOWNLOAD_STATUS = 'api/reports/check_status';
export const REPORT_CREATED_DOWNLOAD = 'api/reports/created/download/';
export const WIDS_API = 'api/sites/attack/list/';
export const WIDS_REPORT_DELETE = 'api/sites/attack/delete/';
export const EDIT_ALARM_REPORT = 'api/reports/retrieve/';
export const ACCOUNTS_ADMIN_DETAILS = 'api/accounts/admin/details/';
export const DEVICE_ALARMS_COUNT = 'api/devices/alarms-count/';
export const REBOOT_SWITCH_API = 'api/switches/manage/reboot/';

export const SWITCHES_ACL_MAC_API = 'api/switches/acl/mac/';
export const SWITCHES_ACE_MAC_API = 'api/switches/acl/mac/entries/';
export const SWITCHES_ACL_IPV4_API = 'api/switches/acl/ipv4/';
export const SWITCHES_ACE_IPV4_API = 'api/switches/acl/ipv4/entries/';
export const SWITCHES_ACL_IPV6_API = 'api/switches/acl/ipv6/';
export const SWITCHES_ACE_IPV6_API = 'api/switches/acl/ipv6/entries/';
export const PORT_RANGE_ENTRIES_API = 'api/switches/acl/port_range/entries/';
export const GET_LINK_KAGGREGATIONS =
	'api/switches/link-aggregations/list-update/';
export const GET_LINK_AGG_API_FOR_PORT_PREVIEW =
	'api/switches/dashboard/lagconfs/';
export const GET_MIRROR_LIST = 'api/switches/mirror/list-update/';
export const UPLOAD_DEVICE_LICENCE = 'api/accounts/license-device/upload/';
export const UPGRADE_TYPE_1 = 'api/devices/lic-update/type1/';
export const UPGRADE_TYPE_2 = 'api/devices/lic-update/type2/';
export const UPGRADE_PREMIUM = 'api/devices/lic-update/premium/';
export const UPGRADE_PREMIUM_PRO = 'api/devices/lic-update/premiumpro/';
export const APPLY_T4 = 'api/devices/lic-update/t4/';
export const GET_HISTORICAL_ALARMS_API = 'api/devices/alarm/history/list/';
export const GET_ALARM_EVENTS_API = 'api/devices/alarms/events/list/';
export const GET_SWITCHES_ALARM_EVENTS_API = 'api/switches/alarms/events/';
export const GET_ACTIVE_ALARMS_API = 'api/devices/alarms/active/list/';
export const EDIT_SWITCH_NETWORK_API = 'api/switches/network/ipv4_management/';
export const GET_IPV4_NETWORK_API = 'api/switches/network/ipv4_network/';
export const GET_IPV6_NETWORK_API = 'api/switches/network/ipv6_network/';
export const GET_IPV6_MANAGEMENT_API = 'api/switches/network/ipv6_management/';
export const GET_SWITCH_NETWORK_API =
	'api/switches/network/management_interface/';
export const GET_LLDP_LOCAL_DEVICE_API = 'api/switches/dashboard/lldplocal/';
export const ALARM_ACK_API = 'api/devices/alarms/ack/';
export const GET_BASIC_SETTINGS_API = 'api/switches/update-retrieve/';
export const EDIT_BASIC_SETTINGS_API = 'api/switches/update-retrieve/';
export const GET_LINK_AGG_API = 'api/switches/link-aggregations/list-update/';
export const GET_PORT_MIRROR_API = 'api/switches/mirror/list-update/';
export const GET_MST_INSTANCE_API = 'api/switches/dashboard/mst_instance/';
export const POST_MST_INSTANCE_API = 'api/switches/mstinstance/';
export const GET_CIST_PORT_SETTINGS = 'api/switches/dashboard/cist_port/';
export const GET_MSTP_PORT_SETTINGS = 'api/switches/dashboard/mst_port/';
export const UPDATE_STP_PORT_SETTINGS = 'api/switches/stp-port/';
export const GET_RSTP_PORT_SETTINGS = 'api/switches/dashboard/rstp_port/';
export const GET_ROOT_BRIDGE_INFORMATION_API =
	'api/switches/dashboard/root_bridge/';
export const GET_GROUP_LIST_BY_SITE = 'api/sites/nested/list/';
export const GET_GROUP_LIST_BY_SITE_SEARCH = 'api/sites/nested/site/search/';
export const MOVE_AP_ENDPOINT = 'api/devices/move/tosite/';
export const FORGOT_PASSWORD_SEND_EMAIL_API = 'api/accounts/forgot-password/';
export const UPDATE_NEWPASSWORD__API = 'api/accounts/user/';
export const GET_POE_SETTINGS_API = 'api/switches/dashboard/poe-utilization/';
export const EDIT_POE_SETTINGS_API = 'api/switches/switchpoe/';
// not using for now.
export const POST_REGISTER_USER = 'api/multitenant/signup/0/';
export const POST_REGISTER_USER_OTP_VERIFY =
	'api/multitenant/otp-verify/tenant-create/1/';
export const POST_REGISTER_USER_RESEND_OTP = 'api/multitenant/signup/1/';
export const USER_REGISTER_ENDPOINT_URL = 'http://ztp-iocloud.hfcl.com/';
export const GET_DATABASE_LIST = 'api/maintenance/node_status/Database/';
export const GET_PCS = 'api/maintenance/node_status/PCS/';
export const GET_ETCD = 'api/maintenance/node_status/ETCD/';
export const GET_APIS_LIST = 'api/maintenance/node_status/Apis/';
export const GET_DOCKER_REGISTRY_LIST =
	'api/maintenance/node_status/Docker_Registry/';
export const GET_LSYNCD = 'api/maintenance/node_status/lsyncd/';
export const GET_KUBE_NODES_LIST = 'api/maintenance/node_status/Kube_Nodes/';
export const GET_KUBE_PODS_LIST = 'api/maintenance/node_status/Kube_Pods/';
export const GET_NTP_SYNC_LIST = 'api/maintenance/node_status/NTP_Sync/';
export const GET_RABBITMQ_NODES_LIST =
	'api/maintenance/node_status/Rabbitmq_Nodes/';
export const GET_REDIS_NODES_LIST = 'api/maintenance/node_status/Redis_Nodes/';
export const GET_NODE_STATUS = 'api/maintenance/node_status/';
export const GET_AP_CLIENTS = 'api/sites/ap-client/list/';
export const GET_CLIENT_MODALS_API = 'api/sites/client-model/';
export const GET_AP_ALARMS = 'api/devices/alarms/count/per-ap/';
export const HOME_DASHBOARD_STATS_API = 'api/statistics/home-dashboard/count/';
export const GROUP_DASHBOARD_STATS_API = 'api/sites/group-dashboard/count/';
export const GET_SWITCH_DASHBOARD_DETAILS =
	'api/switches/dashboard/sw_dashboard/';
export const GET_SWITCH_ALARM_COUNT = 'api/switches/alarm-events/list/0/';
export const GET_SWITCH_INTERFACE_API =
	'api/switches/dashboard/system_mgmt_interface/';
export const GET_SWITCH_PORT_CONFS = 'api/switches/dashboard/portConfs/';
export const GET_POE_UTILISATION = 'api/switches/dashboard/poe-utilization/';
export const GET_CPU_UTILISATION = 'api/switches/cpumemutil/';
export const GET_STATIC_MAC_API = 'api/switches/dashboard/dyn_macacl/';
export const DELETE_STATIC_MAC_ADDRESS_API = 'api/switches/macacl/delete/';
export const ADD_STATIC_MAC_API = 'api/switches/macacl/';
export const MOVE_MAC_API = 'api/switches/move/';
export const GET_NETWORK_INTERFACES_API = 'api/switches/dashboard/interfaces/';
export const GET_NETWORK_ROUTES_API = 'api/switches/dashboard/routes/';
export const GET_NETWORK_NEIGHBOUR_CACHE_API =
	'api/switches/dashboard/neighbour/';
export const GET_PORT_STATICS_API = 'api/switches/dashboard/ports_statistics/';
export const GET_LLDP_REMOTE_DEVICES_API =
	'api/switches/dashboard/remotedevices/';
export const GET_HOME_DASH_BW_API = 'api/statistics/home-dashboard/bandwidth/';
export const GET_AP_DASH_BW_API = 'api/devices/ap-dashboard/bandwidth/';
export const GET_GROUP_DASH_BW_API = 'api/sites/site-dashboard/bandwidth/';
export const GET_RADIO_SITE_DATA = 'api/sites/site-radio/list/';
export const GET_RADIO_SETTING_ATCP = 'api/sites/atpc/retrieve/';
export const GET_RADIO_SETTING_WIPS = 'api/sites/wips/retrieve/';
export const RADIO_SETTING_UPDATE = 'api/sites/radio/update/';
export const WIPS_UPDATE = 'api/sites/wips/update/';
export const ATCP_UPDATE = 'api/sites/atpc/update/';
export const GET_AP_RADIO_SETTING_DATA = 'api/devices/radio/retrieve/';
export const DEVICE_MODEL = 'api/devices/device/model/';
export const ACCESS_POINT_RADIO_SETTING_UPDATE = 'api/devices/radio/update/';
export const GET_COUNTRY_CODE_API = 'api/sites/country-code/list/';
export const GET_TIP_COUNTRY_CODE_API = 'api/sites/Tip-country-code/list/';
export const VIEW_MULTI_PSK = 'api/sites/multi-psk/';
export const VIEW_MULTI_PSK_UPDATE = 'api/sites/multi-psk/update/';
export const GET_SWITCH_TRAFFIC_PERFORMANCE =
	'api/switches/traffic-performance/';
export const GET_AP_SESSION_DURATION_API =
	'api/devices/ap-dashboard/session-duration';
export const GET_TIME_ZONES_SIGNUP = 'api/accounts/signup-time-zone/list/';
export const POST_TENANT_SIGNUP = 'api/multitenant/signup/0/';
export const POST_VERIFY_OTP = 'api/multitenant/otp-verify/tenant-create/1/';
export const GET_ZTP__BANNER_DETAILS = 'api/system/banner/';
export const GET_REGION_DETAILS = 'api/multitenant/region/list/';
export const GET_TENANT_LIST = 'api/multitenant/tenant-list/';
export const DELETE_TENANT = 'api/multitenant/tenant-delete/';
export const ADD_TENANT = 'api/multitenant/tenant-list/';
export const TENANT_DOWNLOAD = 'api/multitenant/inventory/download/';
export const GET_HOST_LIST = 'api/system/cnms-host/details/';
export const RETRIVE_TENANT_LIST = 'api/multitenant/tenant-update/';
export const USER_PERMISSION = 'api/accounts/user-permission/list';
export const NOTIFICATION_TENANT_API = 'api/multitenant/push/notification/';
export const POST_CLONE_GROUP = 'api/sites/clone-group/';
export const POST_EXPORT_GROUP = 'api/sites/export-configurations/';
export const POST_IMPORT_GROUP = 'api/sites/import-configurations/';
export const SITE_DASHBOARD_SSID_LOAD = 'api/sites/site-dashboard/ssid-load/';
export const GET_SITE_BACKUP_API = 'api/maintenance/backup-list/';
export const DELETE_SITE_BACKUP_API = 'api/maintenance/backup-delete-restore/';
export const DOWNLOAD_SITE_BACKUP_API = 'api/maintenance/backup-file-download/';
export const DOWNLOAD_USER_API = 'api/accounts/download/users-list/';
export const SSSI_LOAD_GRAPH_MSG = 'DATA_BANDWIDTH_RETRIEVED_SUCCESSFULLY';
export const SSID_LOAD_GRAPH_MSG = 'SSID_LOAD_RETRIEVED_SUCCESSFULLY';
export const VENDOR_MODELS_API_MSG = 'WIDGET_DATA_LISTED_SUCCESSFULLY';
export const AP_DATA_USAGE_MSG = 'upTime_RETRIEVED_SUCCESSFULLY';
export const AP_GROUP_DATA_USAGE_API =
	'api/statistics/dashboard/group-data-usage-widget/';
export const AP_GROUP_CRITICAL_ALARMS_API =
	'api/statistics/dashboard/group-critical-alarm-widget/';
export const VENDOR_MODEL_API =
	'api/statistics/dashboard/vendor-model-fw/vendor/global/';
export const AP_SSID_CLIENT_COUNT_API =
	'api/statistics/dashboard/ssid-client-count-widget/';
export const AP_SSID_DATA_USAGE_API =
	'api/statistics/dashboard/ssid-data-usage-widget/';
export const GET_AP_CONFIG_API = 'api/devices/showconf/';
export const UPDATE_WIDS_AND_WIPS_CONFIG = 'api/sites/wips/update/';
export const DOWNLOAD_AP_CONFIG_API = 'api/devices/configuration/download/';
export const AP_UPTIME_API = 'api/devices/dashboard/uptime/';
export const SITE_AP_RSSI_API = 'api/sites/site-dashboard/stats/';
export const EACH_AP_MCS_PHY_API = 'api/devices/ap-dashboard/mcs-phy/';
export const EACH_AP_RSSI_API = 'api/devices/ap-dashboard/rssi/';
export const EACH_AP_CHANNEL_INFO_API =
	'api/statistics/current-channel-info-ap/';
export const EACH_AP_CHANNEL_UTILIZATION_API =
	'api/statistics/self-channel-utilization-ap/';
export const AP_EXTENSION_CHANNEL_API = 'api/devices/extension-channels/';
export const AP_ROGUE_API = 'api/devices/ap/rogue/radio/';
export const MOVE_SWITCH_ENDPOINT = 'api/switches/move/tosite/';
export const SWITCH_TEMPRATURE_API = 'api/switches/temperature-readings/';
export const GET_DEVICE_LIST_BY_SITE = 'api/devices/ap-switch-nested/list/';
export const GET_APSWITCH_LIST = 'api/devices/ap-switch/list/';
export const MAC_AGING_TIME_API = 'api/switches/macaging/';
export const GET_NESTED_CHILD_LIST_BY_SITE = 'api/sites/nested/child/list/';

export const ENCRYPT_DECRYPT_KEY = 'canvas@4310';
export const API_RESPONSE_SUCCESS_STATUS_CODE = 200;
export const POST_API_RESPONSE_SUCCESS_STATUS_CODE = 201;
export const API_SUCCESS_CODES = [200, 201];
export const BAD_REQUEST_ERROR_CODE = 400;
export const API_RESPONSE_ERROR_STATUS_CODE_ALREADY_EXISTS = 417;
export const AUTH_TOKEN_ERROR_STATUS_CODE = 401;
export const AUTH_TOKEN_ERROR_STATUS_MSG = 'TOKEN_EXPIRED';
export const INTERNAL_SERVER_ERROR_STATUS = 500;
export const API_RESPONSE_ERROR_STATUS_CODE_NOT_FOUND = 404;
const IS_APRECOMM_GRAPH_ENABLED =
	localStorage.getItem('is_aprecomm_graph_enabled') === 'true';
export const HOME_SITE_DASHBOARD_WIDGET = [
	{ id: 1, name: '(Home)Sites with Highest Data Usage' },
	{ id: 2, name: '(Home)Sites with Least Data Usage' },
	{ id: 3, name: '(Home)Data Bandwidth Range' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 4, name: '(Home)Top Performing Sites' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 5, name: '(Home)Clients' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 6, name: '(Home)Client Models' },
	{ id: 7, name: '(Home)Data Usage on SSID (GB)' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 8, name: '(Home)Top Impacted Sites' },
	{ id: 9, name: '(Home)AP Models & Firmwares' },
	{ id: 10, name: '(Home)Sites with Max Critical alarms' },
	{ id: 11, name: '(Home)Sites with Least Critical alarms' },
	{ id: 12, name: '(Home)Switch Models & Firmwares' },
	{ id: 13, name: '(Home)AP Uptime' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 14, name: '(Home)Issues' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 15, name: '(Home)Active QOE' },
	IS_APRECOMM_GRAPH_ENABLED && {
		id: 16,
		name: '(Home)Wifi Protocol Distribution',
	},
	{ id: 17, name: '(Home)Vendors' },
	{ id: 18, name: '(Home)SSID Load' },
	{ id: 19, name: '(Site)5 GHz Radio Performance' },
	{ id: 20, name: '(Site)2.4 GHz Radio Performance' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 21, name: '(Site)Clients' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 22, name: '(Site)Issues' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 23, name: '(Site)Top Performing APs' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 24, name: '(Site)Top Impacted APs' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 25, name: '(Site)Active QOE' },
	{ id: 26, name: '(Site)AP Models & Firmwares' },
	{ id: 27, name: '(Site)Client Models' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 28, name: '(Site)Application Usage' },
	{ id: 29, name: '(Site)SSID Load' },
	{ id: 30, name: '(Site)Map View' },
	{ id: 55, name: '(Site)APs with Highest Data Usage' },
	{ id: 56, name: '(Site)APs with Least Data Usage' },
	{ id: 57, name: '(Site)APs with Highest Client Count' },
	{ id: 58, name: '(Site)APs with Least Client Count' },
	{ id: 31, name: '(AP)5 GHz Radio Performance' },
	{ id: 32, name: '(AP)2.4 GHz Radio Performance' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 33, name: '(AP)Latching Time' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 34, name: '(AP)Active QOE' },
	{ id: 35, name: '(AP)Session Durations' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 36, name: '(AP)Issues' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 37, name: '(AP)Application Usage' },
	{ id: 38, name: '(AP)Client Models' },
	{ id: 39, name: '(AP)CPU & Memory Utilization' },
	{ id: 59, name: '(AP)Uplink Rate Per Radio' },
	{ id: 60, name: '(AP)Downlink Rate Per Radio' },
	{ id: 40, name: '(AP)Map View' },
	{ id: 41, name: '(Switch)Operation Status' },
	{ id: 42, name: '(Switch)PoE Utilization' },
	{ id: 43, name: '(Switch)CPU Load' },
	{ id: 44, name: '(Switch)Temperature' },
	{ id: 45, name: '(Switch)Traffic' },
	{ id: 46, name: '(Switch)LLDP Local Device' },
	{ id: 61, name: '(Switch)Memory Utilization' },
	{ id: 62, name: '(Switch)Switch Model & Firmwares' },
	{ id: 47, name: '(Switch)Map View' },
	{ id: 48, name: '(Clients)Connectivity' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 49, name: '(Clients)Data Rate' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 50, name: '(Clients)Signal Strength' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 51, name: '(Clients)Application Usage' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 52, name: '(Clients)Latching Time' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 53, name: '(Clients)Session Durations' },
	IS_APRECOMM_GRAPH_ENABLED && { id: 54, name: '(Clients)Issues' },
].filter(Boolean);

/**
 * Constants related to routing.
 *
 * These variables represent routing-related configurations and paths
 */
export const ROUTE_DASHBOARD = '/dashboard';
export const ROUTE_2_WAY_AUTHENTICATION = 'signin/otpverify';
export const UPLOAD_LICENCE_ROUTE = '/license/upload';

/**
 * Other constant messages.
 *
 * These variables represent miscellaneous constant messages used in the application:
 */
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const INAVLID_CREDENTIALS_LOGIN_FAIL = 'Invalid Credentials';
export const PASSWORD_LENGTH_ERR_MSG =
	'Password must be at least 8 characters long';
export const TOKEN_EXPIRED =
	'Your Authorization token has Expired. Please Login Again.';
export const FORBIDDEN_ERROR_MSG = 'Request failed with status code 403';
export const FORBIDDEN_ERROR_STATUS = 403;
export const NOT_DATA_AVAILABLE = 'NO_DATA_AVAILABLE';
export const ACCOUNT_LOCKED = 'ACCOUNT LOCKED FOR 30MIN';
export const VALIDATION_USER_SUCCESS = 'VALIDATION_USER_SUCCESS';
export const USER_LENGTH_ERR_MSG = 'Username empty';
export const VALIDATION_PASSWORD_SUCCESS = 'VALIDATION_PASSWORD_SUCCESS';
export const MINIMUM_REQUIREMENT_PASSWORD =
	'2 Capital letter, 2 Small letter, 2 number and 1 Special Character and must not contain forbidden characters : #, spaces';
export const VALIDATION_EMAIL_SUCCESS = 'VALIDATION_EMAIL_SUCCESS';
export const EMAIL_ERR_MSG = 'Enter valid email';
export const TOKEN_FAILED = 'Not authorized, token failed';
export const UI_STATES = {
	SUCCESS: 'success',
	LOADING: 'loading',
	FAILURE: 'failure',
};
export const HOME_DASH_LOC = 'HOME_DASH_LOC';
export const AP_GROUP_DASH_LOC = 'AP_GROUP_DASH_LOC';
export const EACH_AP_DASH_LOC = 'EACH_AP_DASH_LOC';
export const PHONE_NUMBER_ERR_MSG = 'PHONE_NUMBER_ERR_MSG';
export const PASSWORD_MATCHED_SUCCESS = 'PASSWORD_MATCHED_SUCCESS';
export const PASSWORD_MISMATCH_ERR_MSG = 'PASSWORD_MISMATCH_ERR_MSG';
export const PHONE_NUMBER_SUCCESS = 'PHONE_NUMBER_SUCCESS';

// export const SPLASH_URL = '://' + HOST_URL + ':1852/preAuth/';
export const SPLASH_URL = `://${host}:1852/preAuth/`;
export const GET_EMAIL_API = 'api/accounts/getemail/';
export const GET_OTP_API = 'api/accounts/getotp/';
export const TURN_LED_ON = 'api/mobile/turnon-led/';
export const TURN_LED_OFF = 'api/mobile/turnoff-led/';
export const AP_CPU = 'api/devices/cpumem/';
export const SITE_DEVICES_DATA_USAGE = 'api/sites/ap/usage/';
export const SITE_AP_CLIENT_COUNT = 'api/sites/ap/count/';
export const UPLINK_RATE_RADIO =
	'api/statistics/ap-dashboard/traffic-rate-widget/uplink/';
export const DOWNLINK_RATE_RADIO =
	'api/statistics/ap-dashboard/traffic-rate-widget/downlink/';
export const WIDS_DOWNLOAD = 'api/sites/attack/download/';
export const SHOW_AUDIT_LOG_DETAILS = 'api/accounts/audit-log/retrieve/';
export const DOWNLOAD_AP_CSV_EXCEL = 'api/devices/download/access-point/';
export const CONFIG_AUDIT_API = 'api/devices/config-audit/';
export const SCAN_TIP_ROGUE_AP = "api/devices/wifiscan/";
export const GET_ROLE_BASED_ACCESS_API = 'api/sites/role-based-acl/list/';
export const UPDATE_ROLE_BASED_ACCESS_API = 'api/sites/role-based-acl/update/';
export const DELETE_ROLE_BASED_ACCESS_API = 'api/sites/role-based-acl/delete/';
export const GET_SNMP_LIST_API = 'api/sites/snmp-configuration/list/';
export const DELETE_SNMP_API = 'api/sites/snmp-configuration/delete/';
export const EDIT_SNMP_API = 'api/sites/snmp-configuration/update/';